import { z } from 'zod';

import { DateRangeValue } from 'technical/types';
import { NumberRangeValue } from 'ui/form/number-range-input';

export type FilterType = 'date' | 'ring';

interface DateFilter {
  dateRange: DateRangeValue;
}

interface RingFilter {
  ringRange: NumberRangeValue;
}

export type RangeFilters<CommonFilters extends Record<string, any>> =
  | ({ filterType: 'date' } & CommonFilters & DateFilter)
  | ({ filterType: 'ring' } & CommonFilters & RingFilter);

export const filterTypeSchema = z.union([z.literal('date'), z.literal('ring')]);
